import "../../styles/pageskelton.css";
import SkeletonBox from "./SkeletonBox";

/**
 * DonateSkeleton — used for all donate/ seva pages
 * Pattern: Hero → img+text 2-col → amount grid → CTA
 */
const DonateSkeleton = () => (
  <div className="sk-page">
    <SkeletonBox className="sk-header" />
    <SkeletonBox className="sk-inner-hero" />

    <div className="conatiner">
      <div className="sk-donate-body">
        <SkeletonBox className="sk-donate-img" />
        <div className="sk-donate-text">
          <SkeletonBox className="sk-donate-line-xl" />
          <SkeletonBox className="sk-donate-line-lg" />
          <SkeletonBox className="sk-donate-line-lg" />
          <SkeletonBox className="sk-donate-line-md" />
          <SkeletonBox className="sk-donate-line-md" />
          <SkeletonBox className="sk-donate-line-md" style={{ width: "55%" }} />

          {/* Amount selection */}
          <div className="sk-donate-amount-grid">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <SkeletonBox key={i} className="sk-donate-amount-btn" />
            ))}
          </div>

          <SkeletonBox className="sk-box" style={{ height: 52, borderRadius: 8, marginTop: 8 }} />
        </div>
      </div>
    </div>
  </div>
);

export default DonateSkeleton;
